import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Button, makeStyles } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { getRTLPopperStyles } from '~/modules/common/util';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5, 1.75, 0.5, 1.75),
    borderRadius: theme.spacing(2),
    boxShadow: theme.shadows[0],
    '&:hover': {
      boxShadow: theme.shadows[2]
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.spacing(1.3),
      padding: theme.spacing(0.3, 1)
    }
  }
}));

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    maxWidth: 'fit-content'
  })
}));

export const DelaRejectAllButton = ({
  classes: classesOverride,
  children,
  onClick,
  dataQeId,
  ...otherProps
}) => {
  const intl = useIntl();
  const classes = useStyles({ classes: classesOverride });
  const tooltipPopperClasses = useTooltipPopperStyles();

  return (
    <Tooltip
      classes={tooltipPopperClasses}
      aria-label={intl.formatMessage({
        id: 'dela.rejectAll'
      })}
      placement="bottom"
      title={intl.formatMessage({
        id: 'dela.rejectSuggestions'
      })}
    >
      <Button
        variant="contained"
        {...otherProps}
        className={classes.root}
        classes={classes}
        onClick={onClick}
        data-qe-id={dataQeId}
      >
        {children}
      </Button>
    </Tooltip>
  );
};

DelaRejectAllButton.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
  dataQeId: PropTypes.string
};

export default DelaRejectAllButton;
